<template>
    <div>
        <b-modal
            id="update-profile-popup"
            ref="modal"
            title="Update Profile"
            size="sm"
            modal-class="hide-footer"
            :hide-header-close="loading"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            @hidden="onHidden"
            @show="setUserDetails"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12 row-min-space">
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-2"
                                    label="First Name"
                                    label-for="first-name"
                                >
                                    <b-form-input
                                        id="first-name"
                                        v-model="formData.firstName"
                                        v-validate="{
                                            required: true,
                                            max: 50,
                                        }"
                                        name="first name"
                                        type="text"
                                        :class="{
                                            'is-invalid':
                                                errors.has('first name'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter first name"
                                    ></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-3"
                                    label="Last Name"
                                    label-for="last-name"
                                >
                                    <b-form-input
                                        id="last-name"
                                        v-model="formData.lastName"
                                        v-validate="{
                                            required: true,
                                            max: 50,
                                        }"
                                        name="last name"
                                        type="text"
                                        :class="{
                                            'is-invalid':
                                                errors.has('last name'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter last name"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-4"
                            label="Email Address"
                            label-for="email-address"
                        >
                            <b-form-input
                                id="email-address"
                                v-model="formData.email"
                                v-validate="{
                                    required: true,
                                    email: true,
                                }"
                                name="email"
                                type="email"
                                :class="{
                                    'is-invalid': errors.has('email'),
                                }"
                                autocomplete="no"
                                placeholder="Enter email address"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Update"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
            <base-toast></base-toast>
        </b-modal>

        <b-modal
            ref="otpmodal"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <otp-modal
                v-if="is_data_fetched"
                :data="otpData"
                heading="Two-Factor Authentication"
                @verificationStatus="otpResponse"
                @reSendOTP="reSendOTP"
            ></otp-modal>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
const userUpdateApi = new resource('system-users/update-profile')
import OtpModal from '@/components/registration/OtpModal.vue'
import request from '@/utils/request'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: { OtpModal },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
            is_data_fetched: false,
            otpData: null,
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'userId', 'hidePopup', 'user']),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > methods
    mounted() {},
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Initialize formData
         *
         * @return {formData}
         */
        initializeFormData() {
            return {
                _id: null,
                firstName: '',
                lastName: '',
                email: '',
                //dataSegmentIds: [],
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is submit
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                let obj = {
                    verificationStatus: true,
                }
                // await this.otpResponse(obj)
                await this.sendOPT(this.user)
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
        async setUserDetails() {
            if (this.userId) {
                let data = this.user
                this.formData._id = this.userId
                this.formData.username = data.username
                this.formData.firstName = data.firstName
                this.formData.lastName = data.lastName
                this.formData.email = data.email
                if (data.avatar) {
                    this.formData.profilePicture.originalName =
                        data.avatar.originalName
                    this.formData.profilePicture.fileName = data.avatar.fileName
                }
                // this.formData.roleId = data.roleId
                this.formData.dataSegmentIds = data.dataSegmentIds
            }
        },
        async sendOPT(value) {
            try {
                let phoneNumber = value.phoneNumber
                let fullName = value.firstName
                let email = value.email
                this.$store.commit('setLoading', true)

                const formData = {
                    mobileNo: phoneNumber,
                    name: fullName,
                    email: email,
                    emailText: true,
                }
                const { data } = await request({
                    url: `/configurations/generate-otp-auth/`,
                    method: 'post',
                    data: formData,
                })

                if (data) {
                    this.is_data_fetched = true
                    data.data.phoneNumber = phoneNumber
                    this.otpData = data
                    this.$refs.otpmodal.show()
                }

                this.showPageLoader = false
                // this.fields = data.data
            } catch (error) {
                console.log('OTP error: ' + error)
            }

            this.$store.commit('setLoading', false)
        }, // End of sendOtp() method

        async reSendOTP() {
            await this.sendOPT(this.user)
        }, // End of reSendOTP() method

        async otpResponse(data) {
            console.log('otp resp-----', data)
            if (data) {
                try {
                    this.$store.commit('setLoading', true)
                    this.formData.otp = data.otp
                    this.formData.token = data.token
                    let encryptedForm = this.CryptoJS.AES.encrypt(
                        JSON.stringify(this.formData),
                        process.env.VUE_APP_CSK
                    ).toString()
                    var response = await userUpdateApi.update(
                        this.formData._id,
                        { data: encryptedForm }
                    )
                    console.log('res', response)

                    if (response) {
                        if (response.status === 200) {
                            response.data.data = this.CryptoJS.AES.decrypt(
                                response.data.data,
                                process.env.VUE_APP_CSK
                            ).toString(this.CryptoJS.enc.Utf8)
                            this.$store.commit(
                                'setUser',
                                JSON.parse(response.data.data)
                            )
                            this.$store.commit(
                                'setSuccess',
                                response.data.message
                            )
                            this.$store.commit('setLoading', false)
                            this.$refs.otpmodal.hide()
                            this.$refs.modal.hide()
                        } else {
                            this.$store.commit(
                                'setError',
                                response.data.errors.Error
                            )
                            this.$store.commit('setLoading', false)
                        }
                    }

                    this.$store.commit('setLoading', false)
                } catch (e) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', e)
                }
            } else {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', 'Could not get OTP')
            }
            // this.$store.commit('setLoading', false)
        }, // End of otpResponse() method
    }, // End of Component > mounted
}
</script>
